import { PAYGInfoModal } from "./components/PAYGInfoModal";

import { Text, Spacing } from "@otta/design";

const videos = [
  {
    videoUrl: "https://vimeo.com/1101495264",
    children: (
      <Spacing size={-3}>
        <Text>You can now publish a job, by clicking 'Create a job'.</Text>
        <Text>
          Settings and Companies tabs allow you to invite other team members to
          your account, change or add an ATS, view your billing information and
          more!
        </Text>
        <Text>
          Watch our profile optimisation video to ensure you're set up for the
          best results.
        </Text>
      </Spacing>
    ),
    heading: "Welcome to your account!",
  },
  {
    videoUrl: "https://vimeo.com/1101494147",
    children: (
      <Spacing size={-3}>
        <Text>
          On Welcome to the Jungle, candidates apply to work at your business,
          not just to do a job. Your company profile is the most vital asset to
          market yourself and align with the candidates who match your needs.
        </Text>
        <Text>
          Watch the video for all of our top tips to authentically showcasing
          your business.
        </Text>
      </Spacing>
    ),
    heading: "Build your company profile to see the best results",
  },
  {
    videoUrl: "https://vimeo.com/1101495655",
    children: (
      <Spacing size={-3}>
        <>
          <Text>
            No ATS? No problem. As part of your plan, you get an in-built ATS
            system.
          </Text>
          <Text>
            To post your first role, click 'Post a job' and insert all the vital
            information.
          </Text>
        </>
        <Text>
          If you already have one, go to your 'Settings' and follow the steps to
          let us know or connect it yourself. All jobs will be automatically
          imported to Welcome To The Jungle, which can take 1 working day.
        </Text>
      </Spacing>
    ),
    heading: "Posting a job",
  },
];

export function PAYGAccountCreation(): React.ReactElement | null {
  return (
    <PAYGInfoModal
      videos={videos}
      name="essential-monthly-payg-account-creation"
    />
  );
}
